module.exports = __webpack_public_path__ + "img/sdas.58552f78.svg";